import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { connect } from 'react-redux'

const ErrorController = ({ error }) => {
  useEffect(() => {
    try {
      if (error) {
        Sentry.withScope((scope) => {
          for (const property in error) {
            scope.setExtra(property, error[property])
          }
          let errorMessage = `A problem was captured by the ErrorController: ${error?.message}`
          if (error?.isApiError) {
            errorMessage = `[API] ${errorMessage}`
          }
          Sentry.captureException(
            new Error(errorMessage)
          )
        })
      }
    } catch (e) {
      console.error(e)
    }
  }, [error])

  return null
}

const mapStateToProps = (state) => {
  return {
    error: state?.appError?.error,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorController)
